import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Label = styled.label({
	display: 'inline-block',
	fontWeight: 600,
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: 12,
	overflowWrap: 'anywhere',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FieldContainer = styled.div<{ isInline?: boolean; isCheckbox?: boolean }>({
	display: 'grid',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	gridTemplateColumns: ({ isInline }) => (isInline ? '1fr 1.5fr' : undefined),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	gap: ({ isInline, isCheckbox }) => {
		let result;
		if (isCheckbox) {
			result = token('space.100', '8px');
		}

		if (isInline) {
			result = token('space.200', '16px');
		}

		return result;
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineEditContainerLegacy = styled.div({
	margin: `0 ${token('space.negative.100', '-8px')}`,
	lineHeight: '20px',

	// there is an annoying margin top on Field
	// can't use [class=*Field] 'cause compiler remove the suffix I guess
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'form > *': {
		marginTop: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineEditContainerNew = styled.div({
	lineHeight: '20px',

	// there is an annoying margin top on Field
	// can't use [class=*Field] 'cause compiler remove the suffix I guess
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'form > *': {
		marginTop: 0,
	},
});

export const InlineEditContainer = componentWithFF(
	'products-and-entitlements-details-m2_45b1j',
	InlineEditContainerNew,
	InlineEditContainerLegacy,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CheckboxContainerLegacy = styled.div({
	margin: `0 ${token('space.negative.050', '-4px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CheckboxContainerNew = styled.div({
	margin: `0 ${token('space.050', '4px')}`,
});

export const CheckboxContainer = componentWithFF(
	'products-and-entitlements-details-m2_45b1j',
	CheckboxContainerNew,
	CheckboxContainerLegacy,
);
